import { render, staticRenderFns } from "./project_edit_form.vue?vue&type=template&id=4055de4f&scoped=true&"
import script from "./project_edit_form.vue?vue&type=script&lang=js&"
export * from "./project_edit_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4055de4f",
  null
  
)

export default component.exports